import { useQueries, useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import {
  FetchLocationsResponse,
  Support,
} from '@weave/schema-gen-ts/dist/schemas/syncapp/support/support.pb';
import { authorizedFetch } from 'helpers/utils';
import { WhitelistedLocationsReply } from '../../components/sync-app/sync-app.types';
import { fetchWhitelistedLocations } from './api';

export const SyncAppSettingsQueryKeys = {
  LOCATION: 'sync-app-settings-location',
  WHITELISTED_LOCATIONS: 'sync-app-whitelisted-locations',
};

const useLocationsDuringOnboardingQuery = (
  locationId: string,
  integration: string,
  data: Record<string, string>,
  options?: UseQueryOptions<FetchLocationsResponse, Error>
) => {
  return useQuery<FetchLocationsResponse, Error>({
    queryKey: [SyncAppSettingsQueryKeys.LOCATION, locationId, integration, data],
    queryFn: () =>
      Support.FetchLocations(authorizedFetch(), {
        locationId: locationId,
        integration: integration,
        data: data,
      }),
    retry: false,
    enabled: false,
    retryOnMount: false,
    refetchOnMount: false,
    cacheTime: 0,
    staleTime: 0,
    ...options,
  });
};

const useWhitelistedLocationsQuery = (
  sourceId: string,
  options?: UseQueryOptions<WhitelistedLocationsReply, Error>
) => {
  return useQuery<WhitelistedLocationsReply, Error>({
    queryKey: [SyncAppSettingsQueryKeys.WHITELISTED_LOCATIONS, sourceId],
    queryFn: () => fetchWhitelistedLocations(sourceId),
    retry: false,
    enabled: false,
    retryOnMount: false,
    refetchOnMount: false,
    cacheTime: 0,
    staleTime: 0,
    ...options,
  });
};

export const SyncAppSettingsQueries = {
  useLocationsDuringOnboardingQuery,
  useWhitelistedLocationsQuery,
};
